<template>
    <div v-if="show">
        <!-- Top -->
        <div class="head border-b border-t py-[10px] px-[20px] bg-blue-700 border-gray-400">
            <div class="text-white xl:mx-auto font-bold">
                <div>其他商品</div>
            </div>
        </div>
        <!-- / Top -->

        <div class="pb-6">
            <!-- Head -->
            <div class="bg-blue-200 py-[10px] px-[20px]">
                <div class="flex text-black justify-between xl:mx-auto font-bold">
                    <div>險種名稱 / 保障內容</div>
                    <div>保額</div>
                </div>
            </div>
            <!-- /Head -->

            <!-- Body -->
            <div class="px-[20px] pt-8">
                <template v-if="insures['117']">
                    <div class="xl:mx-auto">
                        <FormInfoInsText 
                            :text="`117 ${ $store.state.ins117.name }`"
                            @click="onClickShowInsInfo('117')"
                        />
                        <!-- 每一人傷害 -->
                        <div class="flex justify-between mt-6">
                            <div> 每一人傷害 </div>
                            <div> {{ ins117DeathCover }} </div>
                        </div>
                        <!-- / 每一人傷害 -->

                        <!-- Price -->
                        <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                            <div
                                v-if="insures['117'].IndirectPrem"
                                class="text-[14px] text-gray-600 text-left xl:mr-6"
                            >
                                定價＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(insures['117'].IndirectPrem) }}
                                </span>
                            </div>
                            <div class="text-[14px] text-right text-pink-800">
                                {{ priceText }}＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(insures['117'].InsPremium) }}
                                </span>
                            </div>
                        </div>
                    <!-- / Price -->
                    </div>
                </template>

                <template v-if="insures['15']">
                    <div class="xl:mx-auto">
                        <FormInfoInsText 
                            :text="`15 ${ $store.state.ins15.name }`"
                            price="30 日"
                            @click="onClickShowInsInfo('15')"
                        />

                        <!-- Price -->
                        <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                            <div
                                v-if="insures['15'].IndirectPrem"
                                class="text-[14px] text-gray-600 text-left xl:mr-6"
                            >
                                定價＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(insures['15'].IndirectPrem) }}
                                </span>
                            </div>
                            <div class="text-[14px] text-right text-pink-800">
                                {{ priceText }}＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(insures['15'].InsPremium) }}
                                </span>
                            </div>
                        </div>
                    <!-- / Price -->
                    </div>
                </template>
                <template v-if="insures['237']">
                    <div class="xl:mx-auto">
                        <FormInfoInsText 
                            :text="`237 ${ $store.state.ins237.name }`"
                            price="500"
                            @click="onClickShowInsInfo('237')"
                        />

                        <!-- Price -->
                        <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                            <div
                                v-if="insures['237'].IndirectPrem"
                                class="text-[14px] text-gray-600 text-left xl:mr-6"
                            >
                                定價＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(insures['237'].IndirectPrem) }}
                                </span>
                            </div>
                            <div class="text-[14px] text-right text-pink-800">
                                {{ priceText }}＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(insures['237'].InsPremium) }}
                                </span>
                            </div>
                        </div>
                    <!-- / Price -->
                    </div>
                </template>
                <!-- 238 道路救援費用附加條款 -->
                <template v-if="insures['238']">
                    <hr
                        v-if="insures['15']"
                        class="border-gray-400 border-t my-8"
                    >
                    <div class="xl:mx-auto">
                        <FormInfoInsText 
                            :text="`238 ${ $store.state.ins238.name }`"
                            @click="onClickShowInsInfo('238')"
                        />

                        <div class="flex mt-5">
                            <div class="w-3/5">
                                拖吊里程
                            </div>
                            <div class="ml-auto">
                                {{ ins238QDay }}
                            </div>
                        </div>

                        <div class="mt-6">
                            <div class="flex justify-between items-center mt-5">
                                <div> 每一事故補償限額 </div>
                                <div> {{ ins238InjuredCover }} </div>
                            </div>

                            <div class="flex justify-between items-center mt-5">
                                <div> 保險期間 </div>
                                <div> {{ ins238DamageCover }} </div>
                            </div>
                        </div>


                        <!-- Price -->
                        <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                            <div
                                v-if="insures['238'].IndirectPrem"
                                class="text-[14px] text-gray-600 text-left xl:mr-6"
                            >
                                定價＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(insures['238'].IndirectPrem) }}
                                </span>
                            </div>
                            <div class="text-[14px] text-right text-pink-800">
                                {{ priceText }}＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(insures['238'].InsPremium) }}
                                </span>
                            </div>
                        </div>
                    <!-- / Price -->
                    </div>
                </template>
                <!-- / 238 道路救援費用附加條款 -->
            </div>
        </div>
    </div>
</template>

<script>
import FormInfoInsText from '@/components/forms/InfoInsText';
/**
  * 查看詳細內容-其他商品
 */
export default {
    name: 'PolicyViewOtherInsurance',
    components: {FormInfoInsText},
    props: {
        /**
         * 已投保項目
         */
        carInsures: {
            type: Array,
            default: () => {
                return [];
            }
        },
        /**
         * 是否已經試算
         */
        isCalculated: {
            type: Boolean,
            default: false
        }
    },
    emits: ['showInsInfo'],
    data() {
        /**
         * @param {Object} insures 有投保的險種
         * @param {Boolean} show 是否顯示此區塊
         */
        return {
            insures: {
                '117': null,
                '15': null,
                '237': null,
                '238': null
            },
            show: false
        };
    },
    computed: {
        // 117
        ins117DeathCover() {
            if (this.insures['117']) {
                return this.$insurance.getCoverText(this.$store.getters['ins117/deathCoverOptionsValid'], this.insures['117'].DeathCover.toString());
            } else {
                return null;
            }
        },
        // 238 道路救援費用附加條款-每一事故補償限額
        ins238InjuredCover() {
            if (this.insures['238']) {
                return this.$insurance.getCoverText(this.$store.getters['ins238/injuredCoverOptionsValid'], this.insures['238'].InjuredCover.toString());
            } else {
                return null;
            }
        },
        // ins238 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins238DamageCover() {
            return this.insures['238'] ? this.$monetary.convertToChineseUnit(this.insures['238'].DamageCover) : null;
        },
        // 238 道路救援費用附加條款-拖吊里程
        ins238QDay() {
            if (this.insures['238']) {
                return this.$insurance.getCoverText(this.$store.getters['ins238/qDayOptionsValid'], this.insures['238'].QDay.toString(), '公里');
            } else {
                return null;
            }
        },
        // 依據是否試算過，顯示「網路優惠價」或「參考價」字樣
        priceText() {
            return this.isCalculated ? '網路優惠價' : '參考價';
        },
    },
    mounted() {
        // 顯示線上投保成功的內容
        this.setContent();
    },
    methods: {
        /**
         * 顯示線上投保成功的內容
         * 
         * @public
         */
        setContent() {
            _.forIn(this.insures, (value, key) => {
                this.insures[key] = _.find(this.carInsures, {InsType: key});
                if (this.insures[key]) this.show = true;
            });
        },
        /**
         * 顯示險種介紹（有代碼的險種說明）
         * 
         * @param {String} insType 險種
         * @public
         */
        onClickShowInsInfo(insType) {
            /**
             * 重複功能：顯示險種介紹（有代碼的險種說明）
             * @property {String} insType 險種
             */
            this.$emit('showInsInfo', insType);
        }
    }
};
</script>
